import axios from "axios";
import { BASE_URL } from "../misc/Static_routes";
import { toast } from "react-toastify";
import axiosInstance from "../config/axiosConfig";

axios.defaults.withCredentials = true;

const notify = (message) => toast.error(`${message}`, {});
const notifySuccess = (message) => toast.success(`${message}`, {});

// export const getAllCities = () => {
//   const result = axios
//     .get(`${BASE_URL}/api/city`, {
//       withCredentials: true,
//     })
//     .then((response) => {
//       const responseOK =
//         response && response.status === 200 && response.statusText === "OK";

//       if (responseOK) {
//         return response.data;
//       }
//     })
//     .catch((error) => {
//       console.log("error", error);
//     });

//   return result;
// };

export const getAdminAllCities = () => {
  const result = axios
    .get(`${BASE_URL}/api/admin/city`, {
      withCredentials: true,
    })
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const cityActivation = async (city) => {
  return axios
    .put(`${BASE_URL}/api/city`, city)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });
};

export const getCityByName = (cityName) => {
  const result = axios
    .get(`${BASE_URL}/api/city/${cityName}`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const getAdminCityByName = (cityName) => {
  const result = axios
    .get(`${BASE_URL}/api/admin/city/${cityName}`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const createCity = async (data) => {
  const result = axios
    .post(`${BASE_URL}/api/city`, { data })
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        notifySuccess(response.data.message);
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const updateCityName = async (data, t) => {
  const result = axios
    .put(`${BASE_URL}/api/city`, data)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        notifySuccess(t('cityNameUpdated'));
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const deleteCity = async (data) => {
  const result = axios
    .delete(`${BASE_URL}/api/city`, {data})
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(response?.data?.message);
        return response.data;
      }
    })
    .catch((err) => {
      notify(err?.response?.data?.message);
    });

  return result;
};

export const citiesService = {
  getAllCities: () => axiosInstance.get('/api/city', {
    withCredentials: true
  }),
    // .then(res => res.data.cities)
    // .catch(err => console.log("error", err)),
  getCityByName: (cityName) => axiosInstance.get(`/api/city/${cityName}`)
}